import { AutoComplete, Button, Divider, Input } from "antd"
import { SearchOutlined } from "@ant-design/icons";
import { useState } from "react";
import { IRootState } from "../../redux/store";
import { useSelector } from "react-redux";

interface BankSelectorProps {
  active: (arg0: boolean) => any;
  selection: (arg0: any) => void;
}

export const BankSelector: React.FC<BankSelectorProps> = ({ active, selection }) => {

  const [dropdownOpen, setDropdownOpen] = useState<boolean>(false);
  const providers = useSelector((state: IRootState) => state.provider.value.providers)

  const selectBank = (value: string) => {
    const bankFound = providers.find((bank: any) => bank.display_name === value);
    selection(bankFound);
    setDropdownOpen(false);
  }

  const searchFilteredBanks = () => {
    selection(null);
    setDropdownOpen(true)
  }

  const renderOptions = () => {
    let data: { label: any, value?: any }[] = [];
    providers.forEach((bank: any) => {
      if(!data.includes(bank)) {
        data.push({
          label:
            <div key={bank.display_name} className='bank-option'>
              <img src={`/bankLogos/${bank.logo}`} className={`${(bank.logo === 'CajaRural.svg' || bank.logo === 'DefaultBank.svg') && 'reduced-logo'}`} alt='bank-logo' />
              <Divider className='bank-option-divider' type='vertical' />
              <div>{bank.display_name}</div>
            </div>,
          value: bank.display_name
        })
      }
    })
    return data;
  }

  return (
    <AutoComplete
      allowClear={true}
      options={renderOptions()}
      notFoundContent='Ningún resultado coincide con la búsqueda'
      className='bank-autocomplete'
      placeholder='Buscador de bancos'
      popupClassName="bank-options-dropdown"
      onDropdownVisibleChange={() => active(true)}
      onFocus={() => setDropdownOpen(true)}
      onBlur={() => setDropdownOpen(false)}
      onSelect={(option) => selectBank(option)}
      onSearch={() => searchFilteredBanks()}
      filterOption={true}
      backfill={true}
      open={dropdownOpen}
      listHeight={380}
    >
      <Input
        suffix={(
          <Button className="search-btn" size="large" type="link">
            <SearchOutlined />
          </Button>
        )}
      />
    </AutoComplete>
  )
}
